import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "tw-flex" };
const _hoisted_2 = { class: "tw-mx-auto tw-max-w-screen-2xl tw-overflow-hidden sm:tw-w-[1320px] tw-w-full pt-3 sm:tw-mt-0 tw-mt-5 tw-rounded-2xl" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Tabs = _resolveComponent("Tabs");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Tabs)
        ])
    ]));
}
